/**
 * Images tab: which fields stay visible vs behind “More details”.
 * Review needs the photo, id, captions, place, and detection status up front.
 */

export const IMAGE_SUMMARY_KEYS = [
  "photoId",
  "imageUrl",
  "caption_localized",
  "caption_source",
  "keyword",
  "gallery_role",
  "location",
  "landmark_detection",
  "photoUrl",
] as const;

export const IMAGE_DETAIL_KEYS = [
  "caption_source_kind",
  "location_source",
  "photographer",
  "attribution",
  "creditLine",
  "license",
  "licenseUrl",
  "wikiTitle",
  "wikidata_id",
  "wikidata_url",
  "wikidata_source",
  "landmark",
  "landmark_source",
  "focalX",
  "focalY",
  "imageWidth",
  "imageHeight",
  "orientation",
  "provider",
  "description",
] as const;

export type ImageSummaryKey = (typeof IMAGE_SUMMARY_KEYS)[number];
export type ImageDetailKey = (typeof IMAGE_DETAIL_KEYS)[number];

export function isImageSummaryKey(key: string): key is ImageSummaryKey {
  return (IMAGE_SUMMARY_KEYS as readonly string[]).includes(key);
}

export function isImageDetailKey(key: string): key is ImageDetailKey {
  return (IMAGE_DETAIL_KEYS as readonly string[]).includes(key);
}
